import { Dialog, DialogTitle } from "@mui/material";
import "./style.css";

const CustomizedAlertDialog = (props) => {
    const { open, title, buttonLabel, onButtonClick, children } = props;

    return (
            <Dialog open={open}>
                <div className="customized-alert-dialog">
                    <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '2.5rem' }}>{title}</DialogTitle>
                    <div className="dialog-body-container">
                        {children}
                        <div className="navigate-button">
                            <button className="return-button" type="button" onClick={onButtonClick}>{buttonLabel}</button>
                        </div>
                    </div>
                </div>
            </Dialog>
    );
};

export default CustomizedAlertDialog;
